/* tslint:disable */
export enum OperationType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  NOT_STARTED = 'NOT_STARTED',
  WORKING = 'WORKING',
  APPROVED = 'APPROVED'
}
